/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeetDayCompany } from '../../models/meet-day-company';
import { MeetDayCompanyRegistration } from '../../models/meet-day-company-registration';

export interface UpdateStudentCapForCompany$Params {
  id: string;
      body?: MeetDayCompanyRegistration
}

export function updateStudentCapForCompany(http: HttpClient, rootUrl: string, params: UpdateStudentCapForCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayCompany>> {
  const rb = new RequestBuilder(rootUrl, updateStudentCapForCompany.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeetDayCompany>;
    })
  );
}

updateStudentCapForCompany.PATH = '/meetday/{id}/company/updatestudentcap';
